import { domainCode } from '../../constants/staticPageConstants';

export const B2C_slugs = [
  'union-budget',
  'epfo',
  'personal-finance',
  'salary-income',
  'income-tax',
  'business',
  'business-income',
  'efiling',
  'accounting-and-auditing',
  'accounting-standards',
  'accounting-ratio',
  'financial-reports',
  'working-capital-management',
  'compliance-financial-analysis',
  'corporate-tax',
  'notices',
  'uncategorized',
  'tds-return',
  'sme-loans',
  'inventory-basics',
  'best-ways-to-invest-in-us-stocks-from-india',
  'home-loan',
  'car-loan',
  'education-loan',
  'personal-loan',
  'credit-card',
  'voter-id',
  'aadhaar-card',
  'pan-card',
  'digital-signature-certificate-get-dsc',
  'income-tax-refunds',
  'verification',
  'house-property',
  'other-sources-of-income',
  'freelance-professional-business-income',
  'capital-gains-income',
  'efiling-income-tax-return',
  'income-tax-e-verification-evc',
  '80c-80-deductions',
  'other-income-sources',
  'advance-tax',
  'pay-income-tax-due',
  'income-tax-for-nri',
  'income-tax-notices',
  'tds',
  'huf-hindu-undivided-family',
  'income-tax-refund',
  'mutual-funds',
  'investments',
  'company-registration',
  'manage-business',
  'insurance',
  'life-insurance',
  'health-insurance',
  'general-insurance',
  'other-investments',
  'startup-funding',
  'business-resources',
  'deposit',
  'loans',
  'financial-planning',
  'mutual-fund-investment',
  'mutual-fund-types',
  'mutual-fund-analysis',
  'freelance-professional-business-income-2',
  'cibil-credit-report',
  'direct-funds',
  'net-banking',
  'saving-schemes',
  'itr',
  'government-schemes',
  'government-schemes-individuals',
  'government-schemes-businesses',
  'best-mutual-funds-india',
  'calculators',
  'emi-calculator',
  'car-loan-emi-calculator',
  'fd-calculator',
  'home-loan-emi-calculator',
  'personal-loan-emi-calculator',
  'ppf-calculator',
  'rd-calculator',
  'sip-calculator',
  'education-loan-emi-calculator',
  'crypto',
  'stocks',
  'stock-market-india',
  'stock-investments',
  'Intraday-trading',
  'income-tax',
  'income-tax-refund',
  'itr',
  'notices',
  'other-sources-of-income',
  'pay-income-tax-due',
  'tds-return',
  'land-records-in-india',
];
export const CONTENT_PAGE = 'content';

export const REGIONS_WITH_NON_ENGLISH_PRIMARY = [
  domainCode.cleartaxFR,
  domainCode.cleartaxES,
  domainCode.cleartaxPL,
  domainCode.cleartaxMY,
];
